// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"938474df","219":"1ed80dc5","313":"9992b30e","415":"602b87ad"}[chunkId] + ".chunk.css";
};